import type { JSX } from 'preact';
import styles from './Footer.module.css';
import { Link } from '../Link/Link';

export interface FooterLinkItem {
  label: string;
  href: string;
}

interface FooterProps {
  links: FooterLinkItem[];
}

export function Footer({ links }: FooterProps): JSX.Element | null {
  if (links.length === 0) {
    return null;
  }

  return (
    <footer className={styles.root}>
      {links.map((link) => (
        <div key={`${link.label}:${link.href}`} className={styles.linkWrapper}>
          <Link isExternal href={link.href}>
            {link.label}
          </Link>
        </div>
      ))}
    </footer>
  );
}
